import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database'
import { ADMIN } from 'routes/routes';


const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
};

class Firebase {
  constructor() {
    firebase.initializeApp(config);

    this.auth = firebase.auth();
    this.firestore = firebase.firestore();
    this.storage = firebase.storage();
    this.googleProvider = new firebase.auth.GoogleAuthProvider();
    this.facebookProvider = new firebase.auth.FacebookAuthProvider();
    this.database = firebase.database();
  }

  // *** Auth API ***

  // doUserCreate = (email, password,isAdmin) => 
  // this.auth.createUserWithEmailAndPassword(email, password).then(authUser => {
  //   var roles = {}
  //     if(isAdmin){
  //       roles[ADMIN] = ADMIN;
  //     }
  // });
  doUserCreate = (email, password,isAdmin) => 
  this.auth.createUserWithEmailAndPassword(email, password);
  doUserLogin = (email, password) => this.auth.signInWithEmailAndPassword(email, password);

  doUserLogOut = () => this.auth.signOut();

  doUserPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doUserPasswordUpdate = password => this.auth.currentUser.updatePassword(password);

  doConfimPasswordReset = (code, newPassword) => this.auth.confirmPasswordReset(code, newPassword);
  doVerifyPasswordResetCode = code => this.auth.verifyPasswordResetCode(code);

  // Google Sign in
  doGoogleSignInPopup = () => this.auth.signInWithPopup(this.googleProvider);
  doGoogleSignInRedirect = () => this.auth.signInWithRedirect(this.googleProvider);

  // Facebook Sign in
  doFacebookSignInPopup = () => this.auth.signInWithPopup(this.facebookProvider);
  doFacebookSignInRedirect = () => this.auth.signInWithRedirect(this.facebookProvider);

  getFileDownloadUrl = path => {
    const storageRef = this.storage.ref();
    return storageRef.child(path).getDownloadURL();
  };

  //Acoount Page
  getProfile = () => firebase.auth().currentUser;
  // getUserData = (userId) =>  firebase.auth().getUser(userId);
  //check = () => firebase.firestore().collection('stripe_customers').doc('hvGub74cFFPkMD5oHAzNlxu7k632');
  getToken = (token) => firebase.firestore().collection('stripe_customers').doc(token).collection('tokens');
  checkTest = (token) => firebase.firestore().collection('users').doc(token);
 
  getUserDataById = (uid) => {
    const ref = firebase.firestore().collection('users');
    return new Promise((resolve, reject) => {
      setTimeout(function () {

        ref.doc(uid).get()
          .then(function (doc) {
            if (doc.exists) {
              console.log("Users Document data:", doc.data());
              resolve({ status: 'success', user: doc.data() })
            } else {
              resolve({ status: 'error', message: "Doc not found" })
            }
          })
          .catch(function (error) {
            console.log('userRecord Error', error.message)
            reject({ status: 'error', message: error.message })
          });
      }, 100);
    });

  }

  getCurrentUser = (uid) =>{
    var that = this;
    return new Promise((resolve, reject) => {
      setTimeout(function () {
        const dbUser = firebase.auth().currentUser
          console.log('dbUser', dbUser.roles)
            if (!dbUser.roles) {
              dbUser.roles = {};
            }
            resolve(dbUser);
      },100)
    });
  }
}

export default Firebase;
